module.exports = __webpack_public_path__ + "img/hand-point.6bc1f5b2.svg";